import PropTypes from 'prop-types';
import { removeVoipUserPhone } from 'apps/settings/phone-settings/use-call-settings-requests';
import { Modal, ModalBody, Button, useOpenClose, ModalHeaderWithActions } from '@evertrue/et-components';

const RemoveVoipPhoneButton = ({ clearInputs = () => null }) => {
  const [isOpen, openModal, closeModal] = useOpenClose();

  const handleSubmit = async () => {
    await removeVoipUserPhone();
    clearInputs();
    closeModal();
  };

  return (
    <>
      <Button type="destroy" onClick={openModal}>
        Remove Number
      </Button>

      <Modal isOpen={isOpen} closeModal={closeModal} size="small">
        <ModalHeaderWithActions title="Remove Phone Number" closeModal={closeModal} onSubmit={handleSubmit} />
        <ModalBody>Are you sure you want to remove the phone number permanently?</ModalBody>
      </Modal>
    </>
  );
};

RemoveVoipPhoneButton.propTypes = {
  clearInputs: PropTypes.func,
};

export default RemoveVoipPhoneButton;
